import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { canEditPetition, Loading, petitionSlugCanonicalRedirect } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petition-activity',
		path: '/p/:slug/activity',
		component: loadable(async () => import(/* webpackChunkName: "pages/petition_activity" */ './index'), {
			exportName: 'PetitionActivity',
			fallback: Loading,
		}),
		beforeServerRender: async (context) => {
			await petitionSlugCanonicalRedirect(context);
		},
		frame: true,
		restrictedAccess: {
			nonGuestOnly: true,
			role: [canEditPetition('slug')],
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
